import { Button, Grid, Typography } from "@mui/material"
import LockIcon from "@mui/icons-material/Lock"
import { AppNode, EdgeData } from "@features/builder/graph/types"
import { EditRoomLocksMember, isLocked } from "@features/builder/hooks/socketIOHooks"
import { useKeymap } from "@features/keymap/useKeymap"
import { Edge, useReactFlow } from "@xyflow/react"

type ActionButtonsProps = {
  isSaveDisabled?: boolean
  node?: AppNode
  nodeLock?: EditRoomLocksMember
}

export function ActionButtons(props: ActionButtonsProps) {
  const keymap = useKeymap()
  const { getNode } = useReactFlow<AppNode, Edge<EdgeData>>()

  const locked = isLocked(props.nodeLock)
  const lockedNode = props.nodeLock ? getNode(props.nodeLock.lock.node_id) : undefined

  return (
    <Grid container item justifyContent="space-between">
      <Grid item>
        {!locked && (
          <Button
            type="submit"
            variant="contained"
            form="node-form"
            disabled={props.isSaveDisabled}
            title={keymap.getKeymaps().byId.get("save-form")?.desc}
          >
            Save
          </Button>
        )}
        {locked && (
          <span>
            <LockIcon sx={{ verticalAlign: "bottom" }} />
            <Typography sx={{ display: "inline", ml: 1 }}>
              You can not edit this node because <strong>{props.nodeLock?.member.name}</strong> is
              currently editing node <strong>{lockedNode?.data.label}</strong>
            </Typography>
          </span>
        )}
      </Grid>
    </Grid>
  )
}
